export const testAttributes = {
    RATE_TABLE_CONTAINER: 'rate_table_container',
    RATE_TABLE: 'rate_table',
    RATE_TABLE_HEAD: 'rate_table_head',
    RATE_TABLE_BODY: 'rate_table_body',
    RATE_TABLE_DISCLAIMER: 'rate_table_disclaimer',
}

export const tableIds = {
    COLUMN_ID: 'column_',
    ROW_ID: 'row_',
}
